import { KeyValue } from '../../lib/keyboard'
import { getStatuses } from '../../lib/statuses'
import { useEffect, useState } from 'react'
import { BackspaceIcon, PauseIcon, PlayIcon, VolumeUpIcon } from '@heroicons/react/outline'
import Select from 'react-select';
import classNames from 'classnames';
import { song } from '../../lib/words';
import { VALIDGUESSES } from '../../constants/validGuesses';
import KofiButton from "kofi-button"
import Speech from 'speak-tts';



type Props = {
  onChange: (value: any) => void
  onEnter: () => void
  onPlay: () => void
  onPause: () => void
  onSkip: () => void
  isTrackPlaying: boolean
  increase: number
  length: number
  progress: number
  selected: any
  isGameFinished: boolean
  isFirstGuess: boolean
}


export const Input = ({ onChange, onEnter, onPlay, onPause, isTrackPlaying, onSkip, increase, length, selected, isGameFinished, isFirstGuess }: Props) => {

  const [menuOpen, setMenuOpen] = useState(false)
  const [options, setOptions] = useState<{label: string, value: string}[]>([])

  const speech = new Speech();

  speech.init({
    volumn: 0.5,
    lang: 'ko-KR',
  })


  const skip = classNames(
    'rounded-md p-2 px-5',
    'bg-slate-600 text-white'
  )

  const play = classNames(
    'rounded-full p-2',
    isFirstGuess ?  'bg-slate-600' : 'bg-violet-500',
    isGameFinished ? '' : 'transition duration-700 ease-in-out'
  )

  const skipMessage = (isFirstGuess ? 'Skip' : increase == 0 ? 'Skip game' : `Skip (+${increase}s)`)

  return (
    <div className="mb-28">
      {!isGameFinished ? <div className="lyrics flex flex-col justify-center items-center mb-2 mx-2">
        <div className="text-white font-bold mb-2 justify-center items-center">Lyrics</div>
        <div className="text-white text-center">{song.en_lyrics}</div>
        {song.kr_lyrics &&
          <div>
            <div className="w-50 border-t border-gray-600 my-3"></div>
            <div className="flex items-center">
             <div className="text-white text-center mr-2">{song.kr_lyrics}</div>
             {/* {isFirstGuess && <VolumeUpIcon className="h-5 w-5 text-violet-500" onClick={()=>  speechSynthesis.speak(x)} />} */}
            </div>
          </div>
        }
      </div> : <div></div>}
      <div className="audio-progress mb-2 lg:mx-96">
        <div className="w-full bg-gray-200 h-1">
          <div className="bg-violet-500 h-1" style={{ width: "100%" }}></div>
        </div>
      </div>
      <div className="play-button justify-between items-center flex p-2 w-30 lg:mx-96">
        {!isGameFinished ? <div className="text-white">💜</div> : <div></div>}
        <span className={play} onClick={!isTrackPlaying ? onPlay : onPause}>
          {!isTrackPlaying ? <PlayIcon className="h-10 w-10 text-white" aria-hidden="true" /> : <PauseIcon className="h-10 w-10 text-white" aria-hidden="true" />}
        </span>
        {!isGameFinished ?
          <div className="text-white">00:{length.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}</div> : <div></div>
        }
      </div>
      {!isGameFinished && <div className="input-answer p-2 lg:mx-96 sm:mx-20">
        <Select
          value={selected}
          onChange={(value) => onChange(value)}
          options={options}
          isClearable={true}
          menuPlacement="top"
          placeholder="Type a song to select and submit"
          menuIsOpen={menuOpen}
          onInputChange={function(value) {
            if (value=="") {
              setMenuOpen(false)
            } else {
              setOptions(VALIDGUESSES.filter((a)=>a.value.toUpperCase().includes(value.toUpperCase())).slice(0, 7))
              setMenuOpen(true)
            }
          }}
        />
      </div>}
      {!isGameFinished && <div className="flex input-actions p-2 lg:mx-96 sm:mx-20 justify-between">
        <button className={skip} onClick={onSkip}>{skipMessage}</button>
        <button className="rounded-md bg-emerald-500 text-white px-5" onClick={onEnter}>Submit</button>
      </div>}
      {
        isGameFinished &&
        <div className="flex flex-col justify-center items-center">
          <p className="text-white mb-2 font-bold">{`💜 the game?`}</p>
          <KofiButton color="#0a9396" title="Support us via Ko-fi" kofiID="O5O3DWVC" />
        </div>
      }
    </div>
  )
}
